import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import useCancellationToken from 'utils/customHook/useCancellationToken';
import StatusIcon from './StatusIcon';
import { AlignInAreaContainer, AlignInArea } from './IconsAlignArea.css.js';

const IconsAlignArea = (props) => {
  const cancellationToken = useCancellationToken();
  const [enableAreaDatas, setEnableAreaDatas] = useState(null);
  const areas = useSelector(store => store.areas.area);

  useEffect(() => {
    // 지역별 장치 데이터 입력
    const enableAreaDatas = areas.map((data) => {
      const modulesInSelectedArea = props.iconData.filter(x => x.area !== null && x.area.areaIdx === data.areaIdx);

      if (modulesInSelectedArea.length === 0) {
        return { areaStatusFlag: 0 }
      }

      const datasOrderByStatus = modulesInSelectedArea.sort((a, b) => {
        return b.statusFlag - a.statusFlag;
      });

      return {
        statusDatas: datasOrderByStatus,
        areaStatusFlag: datasOrderByStatus[0].statusFlag,
        ...data
      }
    });

    // 지역이 설정되지 않은 장치 데이터 입력
    const notInstallTypeModuleDatas = props.iconData.filter(x => x.area === null);

    if (notInstallTypeModuleDatas.length > 0) {
      enableAreaDatas.push({
        areaIdx: 0,
        areaNm: "미고정",
        areaStatusFlag: notInstallTypeModuleDatas[0].statusFlag,
        statusDatas: notInstallTypeModuleDatas
      });
    }

    // 순서정렬
    const sortEnableAreaDatas = enableAreaDatas.sort((a, b) => {
      return b.areaStatusFlag - a.areaStatusFlag;
    });

    if (cancellationToken.isCancelled) {
      return
    }

    setEnableAreaDatas(sortEnableAreaDatas);
  }, [props, cancellationToken]);

  useEffect(() => () => cancellationToken.cancel(), []);

  if (!enableAreaDatas) {
    return <></>
  }

  return (
    <AlignInAreaContainer>
      {
        enableAreaDatas.map((data) => {
          if (data.statusDatas) {
            return (
              <AlignInArea key={data.areaIdx} >
                <span>{data.areaNm}</span>
                <div className="iconBox">
                  {
                    data.statusDatas.map((statusData) => {
                      return (
                        <StatusIcon key={`${statusData.title}_${statusData.moduleIdx}`}
                          alignOption='area'
                          {...statusData} />
                      )
                    })
                  }
                </div>
              </AlignInArea>
            )
          }
        })
      }
    </AlignInAreaContainer>
  )
}

export default IconsAlignArea;